import React from 'react';
import {Field} from 'formik';
import {
    FormControl,
    InputLabel, MenuItem, Select,
    TextField, ToggleButton, ToggleButtonGroup,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2";


function PatrimoineDataField({...props}) {
    const {values, errors, mode, clients, handleChange, handleBlur} = props;

    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations Patrimoine</Typography>
            </Grid>
            {mode === "edit" &&
                <Grid container size={12} alignItems={"center"}>
                    <Grid size={3}>
                        Client <span className="asterix">*</span>
                    </Grid>
                    <Grid size={9}>
                        <Field
                            type="text"
                            name="client"
                            value={values.client}
                        >
                            {({field, form}) => (
                                <FormControl fullWidth>
                                    <InputLabel id="label-client">Sélectionner le client :</InputLabel>
                                    <Select
                                        labelId="label-client"
                                        label="Sélectionner le client :"
                                        variant="outlined"
                                        value={values.client ?? ""}
                                        onChange={(event) => {
                                            form.setFieldValue("client", event.target.value)
                                            // handleChange(event.target.value)
                                        }}
                                    >
                                        {clients && clients.map((e) => {
                                            return (
                                                <MenuItem key={e.id} value={e['@id']}>
                                                    {e.libelle}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            )}
                        </Field>
                    </Grid>
                </Grid>
            }

            {/* LIBELLE FIELD */}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        name="libelle"
                        value={values.libelle}
                    >
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.libelle && form.touched.libelle)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                name="libelle"
                                label="Libellé"
                                helperText={
                                    form.errors.libelle &&
                                    form.touched.libelle &&
                                    String(form.errors.libelle)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>


            {/* ISGRAFFITI FIELD (only if client supports graffiti service) */}
            {(() => {
                // Determine if the selected/current client has the 'graffiti' service enabled
                const current = props.currentClient;
                let serviceTypes = Array.isArray(current?.serviceTypes) ? current.serviceTypes : null;
                if (!serviceTypes && values.client && Array.isArray(clients)) {
                    const found = clients.find(c => c['@id'] === values.client);
                    serviceTypes = Array.isArray(found?.serviceTypes) ? found.serviceTypes : null;
                }
                const hasGraffiti = Array.isArray(serviceTypes) && serviceTypes.includes('graffiti');
                return hasGraffiti ? (
                    <Grid container size={12} alignItems={"center"} className={"mb-1"}>
                        <Grid size={3}>
                            Type de patrimoine
                        </Grid>
                        <Grid size={9}>
                            <Field type="text" name="isGraffiti" value={values.isGraffiti || false}>
                                {({ field, form }) => (
                                    <ToggleButtonGroup
                                        color={"primary"}
                                        exclusive
                                        size={"medium"}
                                        name="isGraffiti"
                                        value={Boolean(values.isGraffiti)}
                                        onChange={(event, newValue) => {
                                            form.setFieldValue('isGraffiti', newValue);
                                        }}
                                        aria-label={"Type de patrimoine"}
                                    >
                                        <ToggleButton value={false} className={values.isGraffiti === false ? "toggle-button button-selected-primary" : "toggle-button"}>Normal</ToggleButton>
                                        <ToggleButton value={true} className={values.isGraffiti === true ? "toggle-button button-selected-secondary" : "toggle-button"}>Graffiti</ToggleButton>
                                    </ToggleButtonGroup>
                                )}
                            </Field>
                        </Grid>
                    </Grid>
                ) : null;
            })()}

            {/* QUANTITE VARIABLE FIELD (site au forfait, ex: hôpitaux) */}
            <Grid container size={12} alignItems={"center"} className={"mb-1"}>
                <Grid size={3}>
                    Site au forfait
                </Grid>
                <Grid size={9}>
                    <Field type="text" name="quantiteVariable" value={values.quantiteVariable || false}>
                        {({ field, form }) => (
                            <ToggleButtonGroup
                                color={"primary"}
                                exclusive
                                size={"medium"}
                                name="quantiteVariable"
                                value={Boolean(values.quantiteVariable)}
                                onChange={(event, newValue) => {
                                    if (newValue !== null) {
                                        form.setFieldValue('quantiteVariable', newValue);
                                    }
                                }}
                                aria-label={"Site au forfait"}
                            >
                                <ToggleButton value={false} className={values.quantiteVariable === false ? "toggle-button button-selected-primary" : "toggle-button"}>Non</ToggleButton>
                                <ToggleButton value={true} className={values.quantiteVariable === true ? "toggle-button button-selected-secondary" : "toggle-button"}>Oui</ToggleButton>
                            </ToggleButtonGroup>
                        )}
                    </Field>
                    <Typography variant={"caption"} color={"textSecondary"} display={"block"}>
                        Si activé, la quantité réellement lavée est variable et inconnue d'avance : aucune anomalie d'écart de quantité ne sera levée pour ce patrimoine.
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default PatrimoineDataField;
